import { useSuspenseQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';
import {
  productSummaryPageFilterAtom,
  productSummaryRowsPerPageFilterAtom,
  productSummarySortingAtomWithStorage,
} from 'src/atoms/filters/product-summary';
import { fetchProductSummary, ProductSummary } from './../../api/productSummaryApi';
import { productSummaryQueries } from '../queries/productSummaryQueries';

type UseProductSummaryProps = {
  accountRef: string | null;
};

export const useProductSummary = ({ accountRef }: UseProductSummaryProps) => {
  const pageSize = useAtomValue(productSummaryRowsPerPageFilterAtom);
  const page = useAtomValue(productSummaryPageFilterAtom);

  const sorting = useAtomValue(productSummarySortingAtomWithStorage);

  return useSuspenseQuery({
    queryKey: productSummaryQueries.list({
      pageSize,
      page,
      accountRef,
      sorting,
    }),
    queryFn: () => {
      if (accountRef === null) {
        return {
          lastUpdatedTimestamp: null,
          totalNumberOfItems: 0,
          items: [],
        } as ProductSummary;
      }

      return fetchProductSummary({
        accountRef,
        pageSize,
        page,
        sorting,
      });
    },
  });
};
